import React from "react";

/**
 * @component PersonListIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <PersonListIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const PersonListIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="PersonListIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 16c1.33 0 3.216.507 3.683 2l.216.682a.5.5 0 01-.191.562c-.726.504-1.96.756-3.703.756-1.77 0-3.019-.26-3.745-.78a.5.5 0 01-.198-.511l.15-.709c.423-1.38 2.458-2 3.788-2zm0-5a2 2 0 110 4 2 2 0 010-4zm-4.2 1a1 1 0 01-1 1H9a1 1 0 110-2h2.8a1 1 0 011 1zm-1.133 5a1 1 0 01-1 1H9a1 1 0 110-2h1.667a1 1 0 011 1zM19 6a1 1 0 110 2H9a1 1 0 010-2h10zM5 5.5c.83 0 1.5.67 1.5 1.5S5.83 8.5 5 8.5 3.5 7.83 3.5 7 4.17 5.5 5 5.5zm0 5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5zm0 5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5z"
      />
    </svg>
  )
);
PersonListIcon.displayName = "PersonListIcon";
export default PersonListIcon;
